"use client";

import { useLanguage } from "@/i18n/LanguageContext";

interface ArtDecoHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function ArtDecoHero({ h1, subhead, zips }: ArtDecoHeroProps) {
  const { t, currentLang } = useLanguage();
  return (
    <section className="relative w-full min-h-[65vh] flex overflow-hidden">
      <div
        className="relative w-full lg:w-[70%] bg-[#064e3b] flex items-center px-6 md:px-12 py-20"
        style={{ clipPath: "polygon(0 0, 100% 0, 92% 100%, 0 100%)" }}
      >
        <div className="max-w-xl">
          <p className="text-[#047857] uppercase tracking-[0.2em] text-sm font-bold mb-6">
            {currentLang === "es" ? "Reparación de Ventanas para Casas en Miami Beach" : "Window Repair for Miami Beach Homes"}
          </p>
          <h1 className="text-white text-4xl md:text-5xl font-bold italic mb-6 leading-tight">
            {h1 || t("miamiBeach.h1")}
          </h1>
          <p className="text-white/90 text-lg leading-relaxed mb-8">
            {subhead || t("miamiBeach.subhead")}
          </p>
          {zips && zips.length > 0 && (
            <p className="text-white/60 text-sm mb-4 tracking-wide uppercase font-semibold">
              {zips.join(" · ")}
            </p>
          )}
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-8 py-4 text-sm font-bold rounded-sm hover:bg-[#c2410c] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t("hood.callNow")}
          </a>
        </div>
      </div>
      <div className="hidden lg:flex w-[30%] bg-[#fbbf24] items-center justify-center relative overflow-hidden">
        <span
          className="text-[#064e3b] text-5xl font-black tracking-widest whitespace-nowrap"
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
        >
          MIAMI BEACH
        </span>
      </div>
    </section>
  );
}